// extracted by mini-css-extract-plugin
export default {"link":"PrivacyPolicy_link__8ctjZ","icon":"PrivacyPolicy_icon__6jzyX","active":"PrivacyPolicy_active__P2dof"};